// import React, { useState, useEffect, useContext, useRef } from 'react'
// import { Form } from 'react-router-dom'
// import Application from "../../../StateContext/Application";
// import { Cancel32, DeleteRed32, EditBlueBlue32, submit } from '../../../../../public/LoginImages/importimages';
// import '../master.css'
// import { useLanguage } from '../../../../../lang/langcontext/LanguageContext';

// const Banks = () => {
//       const { language, toggleLanguage, t } = useLanguage();
//   const statecalls = useContext(Application);
//   const { BankMaster, DeductionOperation } = statecalls;

//   const [fetchBanksDetails, setFetchBankDetails] = useState([]);
//   const [formData, setFormData] = useState({
//     BankName: "",
//     AccountNumber: "",
//     IFSCCode: "",
//     Branch: "",
//     AccountHodlerName: "",
//     UseFor: "",
//     DeductionID: ""
//   });

//   const [formErrors, setFormErrors] = useState({
//     BankName: "",
//     AccountNumber: "",
//     IFSCCode: "",
//     Branch: "",
//     AccountHodlerName: "",
//     UseFor: "",
//     DeductionID: ""
//   });

//   const [tableData, setTableData] = useState([]);
//   const [editId, setEditId] = useState(null);
//   const [isIfscValid, setIsIfscValid] = useState(null);
//   const [ifscMessage, setIfscMessage] = useState("");
//   const formdataref = useRef(null)

//   const validateIfsc = async (IFSC_CODE) => {
//     if (!IFSC_CODE) {
//       setIsIfscValid(null);
//       setIfscMessage("IFSC Code is required");
//       return;
//     }

//     IFSC_CODE = IFSC_CODE.toUpperCase();

//     try {
//       const response = await fetch(`https://ifsc.razorpay.com/${IFSC_CODE}`);
//       if (response.ok) {
//         setIsIfscValid(true);
//         setIfscMessage("Correct");
//       } else {
//         setIsIfscValid(false);
//         setIfscMessage("Invalid IFSC Code");
//       }
//     } catch (error) {
//       setIsIfscValid(false);
//       setIfscMessage("Error validating IFSC Code");
//       console.error("Error validating IFSC code:", error);
//     }
//   };

//   const getbudget = async () => {
//     let data = await BankMaster("get");
//     if (data && Array.isArray(data)) {
//       setTableData(data);
//     } else {
//       setTableData([]);
//       console.error("Error: Data is not an array or undefined.");
//     }
//   };

//   useEffect(() => {
//     getbudget();
//   }, []);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     let errorMessage = "";
//     const validUserName = /^[a-zA-Z0-9 ]*$/;
//     if (name === "BankName" && !validUserName.test(value)) {
//       errorMessage = "Only alphanumeric characters and spaces are allowed.";
//     }
//     const validAccountNumber = /^[0-9]*$/;
//     if (name === "AccountNumber" && !validAccountNumber.test(value)) {
//       errorMessage = "Only numeric characters are allowed.";
//     }
//     const validAccountHolderName = /^[a-zA-Z ]*$/;
//     if (name === "AccountHodlerName" && !validAccountHolderName.test(value)) {
//       errorMessage = "Only alphabets and spaces are allowed.";
//     }
//     if ((name === "Branch") && !validUserName.test(value)) {
//       errorMessage = "Only alphanumeric characters and spaces are allowed.";
//     }
//     if (name === "IFSCCode") {
//       validateIfsc(value);
//     }

//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//     setFormErrors({
//       ...formErrors,
//       [name]: errorMessage,
//     });

//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {

//       const errors = {};
//       if (!formData.BankName) errors.BankName = "Bank Name is required.";
//       if (!formData.AccountNumber) errors.AccountNumber = "Account Number is required.";
//       if (!formData.IFSCCode || !isIfscValid) errors.IFSCCode = "Valid IFSC Code is required.";
//       if (!formData.Branch) errors.Branch = "Branch Name is required.";
//       if (!formData.AccountHodlerName) errors.AccountHodlerName = "Account Holder Name is required.";
//       if (!formData.UseFor) errors.UseFor = "Please select an option for Deduction Type.";
//       if (!formData.DeductionID) errors.DeductionID = "Please select an option for Deduction Type.";
//       if (Object.keys(errors).length > 0) {
//         setFormErrors(errors);
//         return;
//       }

//       const isDuplicate = tableData.some(
//         (item) => String(item.DeductionID) === String(formData.DeductionID)
//       );
//       if (isDuplicate) {
//         alert("This Deduction Type is already linked to another bank entry!");
//         return;
//       }

//       let action = editId ? "edit" : "insert";
//       let payload = editId ? { ...formData, id: editId } : formData;
//       console.log("Action:", action);
//       console.log("Payload:", payload);

//       let data = await BankMaster(action, payload);
//       console.log("Response Data:", data);

//       alert(data.message);
//       getbudget();
//       setEditId(null);
//       setFormData({
//         BankName: "",
//         AccountNumber: "",
//         IFSCCode: "",
//         Branch: "",
//         AccountHodlerName: "",
//         UseFor: "",
//         DeductionID: ""
//       });
//       setIfscMessage("");

//       getbudget();

//     }
//     catch (err) {
//       alert(err);
//       console.log(err);
//     }
//   };

//   const handleEdit = (item) => {
//     console.log("Edit Item:", item);
//     setFormData({
//       BankName: item.Bank_Name,
//       AccountNumber: item.Account_Number,
//       IFSCCode: item.IFSC_CODE,
//       Branch: item.Branch_Name,
//       AccountHodlerName: item.AccountHodlerName,
//       UseFor: item.UseFor,
//       DeductionID: item.DeductionID
//     });
//     setEditId(item.id);
//     validateIfsc(item.IFSC_CODE);
//   };

//   const handleDelete = async (e, id) => {
//     e.preventDefault();
//     console.log("ID DELETE", id);
//     if (window.confirm("Are you sure you want to delete this bank?")) {
//       let data = await BankMaster("delete", id);
//       if (data && data.message === "Bank Deleted Successfully") {
//         alert("Deleted successfully!");
//         getbudget();
//       } else {
//         alert("Delete failed");
//       }
//     }
//   };
//   const resetData = () => {
//     formdataref.current.reset()
//     setFormData([])
//   };

//   const FetchBanksDetailInitally = async () => {
//     try {
//       let res = await DeductionOperation("null", "fetchAllDeductionTypeDetails");
//       setFetchBankDetails(res);
//     }
//     catch (err) {
//       console.log(err);
//     }
//   };

//   useEffect(() => {
//     FetchBanksDetailInitally();
//     getbudget();
//   }, []);

//   const changeOptions = (e, id) => {
//     e.preventDefault();

//     let res = fetchBanksDetails.filter((item) => item.DeductionID == id);
//     console.log(res[0].Deduction_Name);

//     setFormData({ ...formData, UseFor: res[0].Deduction_Name, DeductionID: id });
//   }

//   // console.log("Form Data I selected :: ", formData)
//   console.log("Table Data i get :: ", tableData);

//   // return (
//   //   <div style={{ paddingTop: '20px', backgroundColor: 'rgb(246, 248, 252)', maxHeight: '91vh', overflowY: 'auto' }}>
//   //     <h4 style={{ margin: "10px" }}>Bank Master</h4>
//   //     <Form onSubmit={handleSubmit} ref={formdataref} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//   //       <div style={{ marginTop: 20, display: 'grid', gap: '2rem', width: '70vw', border: 'none', boxShadow: '0px 0px 10px', padding: '30px', backgroundColor: 'white', borderRadius: '10px', flexWrap: "wrap", }}>
//   //         <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
//   //           <div style={{ display: 'grid' }} className="col-5">
//   //             <label className='form-label' style={{ fontWeight: '700' }}>Bank Name</label>
//   //             <input
//   //               type="text"
//   //               className="form-control"
//   //               name="BankName"
//   //               value={formData.BankName}
//   //               onChange={handleInputChange}
//   //             /> {formErrors.BankName && (
//   //               <small style={{ color: "red", fontWeight: "bold" }}>{formErrors.BankName}</small>
//   //             )}
//   //           </div>

//   //           <div style={{ display: 'grid' }} className="col-5">
//   //             <label className='form-label' style={{ fontWeight: '700' }}>Account Number</label>
//   //             <input
//   //               type="text"
//   //               className="form-control"
//   //               name="AccountNumber"
//   //               value={formData.AccountNumber}
//   //               onChange={handleInputChange}
//   //             />{formErrors.AccountNumber && (
//   //               <small style={{ color: "red", fontWeight: "bold" }}>{formErrors.AccountNumber}</small>
//   //             )}
//   //           </div>
//   //         </div>
//   //         <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
//   //           <div style={{ display: 'grid' }} className="col-5">
//   //             <label className='form-label' style={{ fontWeight: '700' }}>IFSC Code</label>
//   //             <input
//   //               type="text"
//   //               className="form-control"
//   //               name="IFSCCode"
//   //               value={formData.IFSCCode}
//   //               onChange={handleInputChange}
//   //             />
//   //             {ifscMessage && (
//   //               <small style={{ fontWeight: '800', color: isIfscValid ? "green" : "red" }}>
//   //                 {ifscMessage}
//   //               </small>
//   //             )}
//   //           </div>

//   //           <div style={{ display: 'grid' }} className="col-5">
//   //             <label className='form-label' style={{ fontWeight: '700' }}>Branch Name</label>
//   //             <input
//   //               type="text"
//   //               className="form-control"
//   //               name="Branch"
//   //               value={formData.Branch}
//   //               onChange={handleInputChange}
//   //             />{formErrors.Branch && (
//   //               <small style={{ color: "red", fontWeight: "bold" }}>{formErrors.Branch}</small>
//   //             )}
//   //           </div>

//   //         </div>
//   //         <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
//   //           <div style={{ display: 'grid' }} className="col-5">
//   //             <label className='form-label' style={{ fontWeight: '700' }}>Account Holder Name</label>
//   //             <input
//   //               type="text"
//   //               className="form-control"
//   //               name="AccountHodlerName"
//   //               value={formData.AccountHodlerName}
//   //               onChange={handleInputChange}
//   //             />{formErrors.AccountHodlerName && (
//   //               <small style={{ color: "red", fontWeight: "bold" }}>{formErrors.AccountHodlerName}</small>
//   //             )}
//   //           </div>

//   //           <div style={{ display: 'grid' }} className="col-5">
//   //             <label className='form-label' style={{ fontWeight: '700' }}>Deduction Type</label>
//   //             <select
//   //               className="form-select"
//   //               name="DeductionID"
//   //               value={formData.DeductionID}
//   //               onChange={(e) => { handleInputChange(e); changeOptions(e, e.target.value) }}
//   //             >
//   //               <option value="" disabled>Select</option>
//   //               {
//   //                 fetchBanksDetails &&
//   //                 fetchBanksDetails.map((val, index) => {
//   //                   return (
//   //                     <option key={index} value={val.DeductionID}>{val.Deduction_Name}</option>
//   //                   )
//   //                 })
//   //               }
//   //             </select>
//   //           </div>
//   //         </div>

//   //         <div style={{ display: 'flex', paddingLeft: '4rem', gap: '10px' }}>
//   //           <button type="submit" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: '#502eff', border: 'none', fontSize: '17px', gap: '4px' }}>{editId ? (<img src='' style={{ width: "1.2rem", paddingBottom: "3px" }} />) : (<img src={submit} alt="Submit" style={{ width: "1.2rem", paddingBottom: "3px" }} />)}{editId ? "Update" : "Submit"} </button>
//   //           <button onClick={resetData} type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: 'red', border: 'none', fontSize: '17px', gap: '4px' }}><img src={Cancel32} style={{ width: '1.2rem', }} /> Cancel</button>
//   //         </div>
//   //       </div>
//   //     </Form>

//   //     {
//   //       tableData &&
//   //       <div style={{ display: 'grid', justifyContent: 'center', padding: "20px 0px 0px 0px", }}>
//   //         <h4 style={{ padding: '10px', fontWeight: '700' }}>Add Tax List</h4>
//   //         <div
//   //           style={{
//   //             display: 'flex',
//   //             justifyContent: 'center',
//   //             width: '75vw',
//   //           }}
//   //         >
//   //           <table
//   //             style={{
//   //               backgroundColor: '#e8f7f3',
//   //               width: '100%',
//   //               borderRadius: '20px,20px 0px 0px',
//   //               overflow: 'hidden',
//   //             }}
//   //           >
//   //             <thead style={{ borderTop: 'none' }}>
//   //               <tr
//   //                 style={{
//   //                   backgroundColor: '#ece9fe',
//   //                   color: 'black',
//   //                   border: 'none',
//   //                   borderRadius: '10px',
//   //                   overflow: 'hidden',
//   //                   height: '2.5rem',
//   //                 }}
//   //               >
//   //                 <th>Sr.No</th>
//   //                 <th>Bank Name</th>
//   //                 <th>Account Number</th>
//   //                 <th>IFSC CODE</th>
//   //                 <th>Branch Name</th>
//   //                 <th>Account Holder Name</th>
//   //                 <th>Use For</th>
//   //                 <th>Actions</th>
//   //               </tr>
//   //             </thead>
//   //             <tbody>
//   //               {tableData.map((item, index) => (
//   //                 <tr key={item.id} style={{
//   //                   borderBottom: '2px dotted #ccc',
//   //                   backgroundColor: 'white'
//   //                 }}>
//   //                   <td>{index + 1}</td>
//   //                   <td>{item.Bank_Name}</td>
//   //                   <td>{item.Account_Number}</td>
//   //                   <td>{item.IFSC_CODE}</td>
//   //                   <td>{item.Branch_Name}</td>
//   //                   <td>{item.AccountHodlerName}</td>
//   //                   <td>{item.UseFor}</td>
//   //                   <td style={{ padding: '5px' }}>
//   //                     <button onClick={() => handleEdit(item)} className="btn btn-custom-edit"
//   //                       style={{
//   //                         width: '5rem',
//   //                         border: '1px solid #502eff',
//   //                         backgroundColor: 'white',
//   //                         borderRadius: '5px',
//   //                         padding: '5px',
//   //                         fontSize: '14px',
//   //                         color: '#502eff',
//   //                         fontWeight: '700'
//   //                       }}
//   //                     >
//   //                       <img className="icon-edit" src={EditBlueBlue32} style={{ width: '1.3rem' }} /> Edit
//   //                     </button>
//   //                     <button onClick={(e) => handleDelete(e, item.DeductionID)} className="btn btn-custom-delete"
//   //                       style={{
//   //                         width: '6rem',
//   //                         border: '1px solid #ee5d50',
//   //                         backgroundColor: 'white',
//   //                         borderRadius: '5px',
//   //                         padding: '5px',
//   //                         marginLeft: '10px',
//   //                         color: '#ee5d50',
//   //                         fontSize: '14px',
//   //                         fontWeight: '700'
//   //                       }}
//   //                     >
//   //                       <img className="icon-delete"
//   //                         src={DeleteRed32}
//   //                         style={{ width: '1.3rem', paddingBottom: '0.2rem' }}
//   //                       />{' '}
//   //                       Delete
//   //                     </button>
//   //                   </td>
//   //                 </tr>
//   //               ))}
//   //             </tbody>
//   //           </table>
//   //         </div>
//   //       </div>
//   //     }

//   //   </div>
//   // )
//   return (
//       <div style={{ paddingTop: '20px', backgroundColor: 'rgb(246, 248, 252)', maxHeight: '91vh', overflowY: 'auto' }}>
//         <h4 style={{ margin: "10px" }}>{t("Bank Master")}</h4>
//         <Form onSubmit={handleSubmit} ref={formdataref} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//           <div style={{ marginTop: 20, display: 'grid', gap: '2rem', width: '70vw', border: 'none', boxShadow: '0px 0px 10px', padding: '30px', backgroundColor: 'white', borderRadius: '10px', flexWrap: "wrap", }}>
//             <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
//               <div style={{ display: 'grid' }} className="col-5">
//                 <label className='form-label' style={{ fontWeight: '700' }}>{t("Bank Name")}</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="BankName"
//                   value={formData.BankName}
//                   onChange={handleInputChange}
//                 /> {formErrors.BankName && (
//                   <small style={{ color: "red", fontWeight: "bold" }}>{formErrors.BankName}</small>
//                 )}
//               </div>

//               <div style={{ display: 'grid' }} className="col-5">
//                 <label className='form-label' style={{ fontWeight: '700' }}>{t("Account Number")}</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="AccountNumber"
//                   value={formData.AccountNumber}
//                   onChange={handleInputChange}
//                 />{formErrors.AccountNumber && (
//                   <small style={{ color: "red", fontWeight: "bold" }}>{formErrors.AccountNumber}</small>
//                 )}
//               </div>
//             </div>
//             <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
//               <div style={{ display: 'grid' }} className="col-5">
//                 <label className='form-label' style={{ fontWeight: '700' }}>{t("IFSC Code")}</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="IFSCCode"
//                   value={formData.IFSCCode}
//                   onChange={handleInputChange}
//                 />
//                 {ifscMessage && (
//                   <small style={{ fontWeight: '800', color: isIfscValid ? "green" : "red" }}>
//                     {ifscMessage}
//                   </small>
//                 )}
//               </div>

//               <div style={{ display: 'grid' }} className="col-5">
//                 <label className='form-label' style={{ fontWeight: '700' }}>{t("Branch Name")}</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="Branch"
//                   value={formData.Branch}
//                   onChange={handleInputChange}
//                 />{formErrors.Branch && (
//                   <small style={{ color: "red", fontWeight: "bold" }}>{formErrors.Branch}</small>
//                 )}
//               </div>

//             </div>
//             <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
//               <div style={{ display: 'grid' }} className="col-5">
//                 <label className='form-label' style={{ fontWeight: '700' }}>{t("Account Holder Name")}</label>
//                 <input
//                   type="text"
//                   className="form-control"
//                   name="AccountHodlerName"
//                   value={formData.AccountHodlerName}
//                   onChange={handleInputChange}
//                 />{formErrors.AccountHodlerName && (
//                   <small style={{ color: "red", fontWeight: "bold" }}>{formErrors.AccountHodlerName}</small>
//                 )}
//               </div>

//               <div style={{ display: 'grid' }} className="col-5">
//                 <label className='form-label' style={{ fontWeight: '700' }}>{t("Deduction Type")}</label>
//                 <select
//                   className="form-select"
//                   name="DeductionID"
//                   value={formData.DeductionID}
//                   onChange={(e) => { handleInputChange(e); changeOptions(e, e.target.value) }}
//                 >
//                   <option value="" disabled>{t("Select")}</option>
//                   {
//                     fetchBanksDetails &&
//                     fetchBanksDetails.map((val, index) => {
//                       return (
//                         <option key={index} value={val.DeductionID}>{val.Deduction_Name}</option>
//                       )
//                     })
//                   }
//                 </select>
//               </div>
//             </div>

//             <div style={{ display: 'flex', paddingLeft: '4rem', gap: '10px' }}>
//               <button type="submit" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: '#502eff', border: 'none', fontSize: '17px', gap: '4px' }}>{editId ? (<img src='' style={{ width: "1.2rem", paddingBottom: "3px" }} />) : (<img src={submit} alt="Submit" style={{ width: "1.2rem", paddingBottom: "3px" }} />)}{editId ? t("Update") : t("Submit")} </button>
//               <button onClick={resetData} type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: 'red', border: 'none', fontSize: '17px', gap: '4px' }}><img src={Cancel32} style={{ width: '1.2rem', }} /> {t("Cancel")}</button>
//             </div>
//           </div>
//         </Form>

//         {
//           tableData &&
//           <div style={{ display: 'grid', justifyContent: 'center', padding: "20px 0px 0px 0px", }}>
//             <h4 style={{ padding: '10px', fontWeight: '700' }}>{t("Bank List")}</h4>
//             <div
//               style={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 width: '75vw',
//               }}
//             >
//               <table
//                 style={{
//                   backgroundColor: '#e8f7f3',
//                   width: '100%',
//                   borderRadius: '20px,20px 0px 0px',
//                   overflow: 'hidden',
//                 }}
//               >
//                 <thead style={{ borderTop: 'none' }}>
//                   <tr
//                     style={{
//                       backgroundColor: '#ece9fe',
//                       color: 'black',
//                       border: 'none',
//                       borderRadius: '10px',
//                       overflow: 'hidden',
//                       height: '2.5rem',
//                     }}
//                   >
//                     <th>{t("Sr.No")}</th>
//                     <th>{t("Bank Name")}</th>
//                     <th>{t("Account Number")}</th>
//                     <th>{t("IFSC CODE")}</th>
//                     <th>{t("Branch Name")}</th>
//                     <th>{t("Account Holder Name")}</th>
//                     <th>{t("Use For")}</th>
//                     <th>{t("Actions")}</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {tableData.map((item, index) => (
//                     <tr key={item.id} style={{
//                       borderBottom: '2px dotted #ccc',
//                       backgroundColor: 'white'
//                     }}>
//                       <td>{index + 1}</td>
//                       <td>{item.Bank_Name}</td>
//                       <td>{item.Account_Number}</td>
//                       <td>{item.IFSC_CODE}</td>
//                       <td>{item.Branch_Name}</td>
//                       <td>{item.AccountHodlerName}</td>
//                       <td>{item.UseFor}</td>
//                       <td style={{ padding: '5px' }}>
//                         <button onClick={() => handleEdit(item)} className="btn btn-custom-edit"
//                           style={{
//                             width: '5rem',
//                             border: '1px solid #502eff',
//                             backgroundColor: 'white',
//                             borderRadius: '5px',
//                             padding: '5px',
//                             fontSize: '14px',
//                             color: '#502eff',
//                             fontWeight: '700'
//                           }}
//                         >
//                           <img className="icon-edit" src={EditBlueBlue32} style={{ width: '1.3rem' }} /> {t("Edit")}
//                         </button>
//                         <button onClick={(e) => handleDelete(e, item.DeductionID)} className="btn btn-custom-delete"
//                           style={{
//                             width: '6rem',
//                             border: '1px solid #ee5d50',
//                             backgroundColor: 'white',
//                             borderRadius: '5px',
//                             padding: '5px',
//                             marginLeft: '10px',
//                             color: '#ee5d50',
//                             fontSize: '14px',
//                             fontWeight: '700'
//                           }}
//                         >
//                           <img className="icon-delete"
//                             src={DeleteRed32}
//                             style={{ width: '1.3rem', paddingBottom: '0.2rem' }}
//                           />{' '}
//                           {t("Delete")}
//                         </button>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         }

//       </div>
//     )
// }

// export default Banks;

import React, { useState, useEffect, useContext, useRef } from "react";
import { Form } from "react-router-dom";
import Application from "../../../StateContext/Application";
import {
  Cancel32,
  DeleteRed32,
  EditBlueBlue32,
  submit,
} from "../../../../../public/LoginImages/importimages";
import "../master.css";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext";

const Banks = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const statecalls = useContext(Application);
  const { BankMaster, DeductionOperation } = statecalls;

  const [fetchBanksDetails, setFetchBankDetails] = useState([]);
  const [formData, setFormData] = useState({
    BankName: "",
    AccountNumber: "",
    IFSCCode: "",
    Branch: "",
    AccountHodlerName: "",
    UseFor: "",
    DeductionID: "",
  });

  const [formErrors, setFormErrors] = useState({
    BankName: "",
    AccountNumber: "",
    IFSCCode: "",
    Branch: "",
    AccountHodlerName: "",
    UseFor: "",
    DeductionID: "",
  });

  const [tableData, setTableData] = useState([]);
  const [editId, setEditId] = useState(null);
  const [isIfscValid, setIsIfscValid] = useState(null);
  const [ifscMessage, setIfscMessage] = useState("");
  const formdataref = useRef(null);

  //pagination
  const [filteredProgress, setFilteredProgress] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(tableData.length / itemsPerPage);
  const indexOfLastBill = currentPage * itemsPerPage;
  const indexOfFirstBill = indexOfLastBill - itemsPerPage;
  const sortedProgress = Array.isArray(tableData)
    ? tableData
        .slice() // ✅ prevent state mutation
        .sort((a, b) => new Date(b.Date) - new Date(a.Date))
    : [];
  const currentItems = sortedProgress.slice(indexOfFirstBill, indexOfLastBill);

  const validateIfsc = async (IFSC_CODE) => {
    if (!IFSC_CODE) {
      setIsIfscValid(null);
      setIfscMessage("IFSC Code is required");
      return;
    }

    IFSC_CODE = IFSC_CODE.toUpperCase();

    try {
      const response = await fetch(`https://ifsc.razorpay.com/${IFSC_CODE}`);
      if (response.ok) {
        const data = await response.json();

        // ✅ Auto-fill bank name & branch
        setFormData((prev) => ({
          ...prev,
          BankName: data.BANK || "",
          Branch: data.BRANCH || "",
        }));
        setIsIfscValid(true);
        setIfscMessage("Valid IFSC Code");
      } else {
        setIsIfscValid(false);
        setIfscMessage("Invalid IFSC Code");
      }
    } catch (error) {
      setIsIfscValid(false);
      setIfscMessage("Error validating IFSC Code");
      console.error("Error validating IFSC code:", error);
    }
  };

const getbudget = async () => {
  try {
    const data = await BankMaster("get");

    console.log("Bank List API Response:", data);

    if (Array.isArray(data)) {
      setTableData(data);

      // Reset to page 1 if the refreshed list is shorter
      setCurrentPage(1);
    } else {
      console.error("Bank List API did not return an array:", data);
      setTableData([]);
    }
  } catch (error) {
    console.error("Error fetching banks:", error);
  }
};

  useEffect(() => {
    getbudget();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let errorMessage = "";
    const validUserName = /^[a-zA-Z]*$/;
    // if (name === "BankName" && !validUserName.test(value)) {
    //   errorMessage = "Only alphanumeric characters and spaces are allowed.";
    // }
    if (name === "BankName" || name === "Branch") {
      return;
    }
    const validAccountNumber = /^[0-9]*$/;
    if (name === "AccountNumber" && !validAccountNumber.test(value)) {
      errorMessage = "Only numeric characters are allowed.";
    }
    // const validAccountHolderName = /^[a-zA-Z ]*$/;
    // if (name === "AccountHodlerName" && !validAccountHolderName.test(value)) {
    //   errorMessage = "Only alphabets and spaces are allowed.";
    // }
    // if ((name === "Branch") && !validUserName.test(value)) {
    //   errorMessage = "Only alphanumeric characters and spaces are allowed.";
    // }
    if (name === "IFSCCode") {
      validateIfsc(value);
    }

    setFormData({
      ...formData,
      [name]: value,
    });
    setFormErrors({
      ...formErrors,
      [name]: errorMessage,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const errors = {};
      if (!formData.BankName) errors.BankName = "Bank Name is required.";
      if (!formData.AccountNumber)
        errors.AccountNumber = "Account Number is required.";
      if (!formData.IFSCCode || !isIfscValid)
        errors.IFSCCode = "Valid IFSC Code is required.";
      if (!formData.Branch) errors.Branch = "Branch Name is required.";
      if (!formData.AccountHodlerName)
        errors.AccountHodlerName = "Account Holder Name is required.";
      if (!formData.UseFor)
        errors.UseFor = "Please select an option for Deduction Type.";
      if (!formData.DeductionID)
        errors.DeductionID = "Please select an option for Deduction Type.";
      if (Object.keys(errors).length > 0) {
        setFormErrors(errors);
        return;
      }

      const isDuplicate = tableData.some(
        (item) =>
          String(item.DeductionID) === String(formData.DeductionID) &&
          item.id !== editId,
      );
      
      if (isDuplicate) {
        alert("This Deduction Type is already linked to another bank entry!");
        return;
      }

      let action = editId ? "edit" : "insert";
      let payload = editId ? { ...formData, id: editId } : formData;
      console.log("Action:", action);
      console.log("Payload:", payload);

const data = await BankMaster(action, payload);

console.log("Bank Save Response:", data);

if (data?.status === false) {
  alert(data.message || "Failed to save bank.");
  return;
}

alert(data.message || "Bank saved successfully.");

setEditId(null);

setFormData({
  BankName: "",
  AccountNumber: "",
  IFSCCode: "",
  Branch: "",
  AccountHodlerName: "",
  UseFor: "",
  DeductionID: "",
});

setFormErrors({});
setIsIfscValid(null);
setIfscMessage("");

// Wait for the updated list
await getbudget();
    } catch (err) {
      alert(err);
      console.log(err);
    }
  };

  const handleEdit = (item) => {
    console.log("Edit Item:", item);
    setFormData({
      BankName: item.Bank_Name,
      AccountNumber: item.Account_Number,
      IFSCCode: item.IFSC_CODE,
      Branch: item.Branch_Name,
      AccountHodlerName: item.AccountHodlerName,
      UseFor: item.UseFor,
      DeductionID: item.DeductionID,
    });
    setEditId(item.id);
    validateIfsc(item.IFSC_CODE);
  };

  const handleDelete = async (e, id) => {
    e.preventDefault();
    console.log("ID DELETE", id);
    if (window.confirm("Are you sure you want to delete this bank?")) {
      let data = await BankMaster("delete", id);
      if (data && data.message === "Bank Deleted Successfully") {
        alert("Deleted successfully!");
        getbudget();
      } else {
        alert("Delete failed");
      }
    }
  };
  const resetData = () => {
    formdataref.current.reset();
    setFormData([]);
  };

  const FetchBanksDetailInitally = async () => {
    try {
      let res = await DeductionOperation(
        "null",
        "fetchAllDeductionTypeDetails",
      );
      setFetchBankDetails(res);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    FetchBanksDetailInitally();
    getbudget();
  }, []);

  const changeOptions = (e, id) => {
    e.preventDefault();

    let res = fetchBanksDetails.filter((item) => item.DeductionID == id);
    console.log(res[0].Deduction_Name);

    setFormData({
      ...formData,
      UseFor: res[0].Deduction_Name,
      DeductionID: id,
    });
  };

  // console.log("Form Data I selected :: ", formData)
  console.log("Table Data i get :: ", tableData);

  // return (
  //   <div style={{ paddingTop: '20px', backgroundColor: 'rgb(246, 248, 252)', maxHeight: '91vh', overflowY: 'auto' }}>
  //     <h4 style={{ margin: "10px" }}>Bank Master</h4>
  //     <Form onSubmit={handleSubmit} ref={formdataref} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
  //       <div style={{ marginTop: 20, display: 'grid', gap: '2rem', width: '70vw', border: 'none', boxShadow: '0px 0px 10px', padding: '30px', backgroundColor: 'white', borderRadius: '10px', flexWrap: "wrap", }}>
  //         <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
  //           <div style={{ display: 'grid' }} className="col-5">
  //             <label className='form-label' style={{ fontWeight: '700' }}>Bank Name</label>
  //             <input
  //               type="text"
  //               className="form-control"
  //               name="BankName"
  //               value={formData.BankName}
  //               onChange={handleInputChange}
  //             /> {formErrors.BankName && (
  //               <small style={{ color: "red", fontWeight: "bold" }}>{formErrors.BankName}</small>
  //             )}
  //           </div>

  //           <div style={{ display: 'grid' }} className="col-5">
  //             <label className='form-label' style={{ fontWeight: '700' }}>Account Number</label>
  //             <input
  //               type="text"
  //               className="form-control"
  //               name="AccountNumber"
  //               value={formData.AccountNumber}
  //               onChange={handleInputChange}
  //             />{formErrors.AccountNumber && (
  //               <small style={{ color: "red", fontWeight: "bold" }}>{formErrors.AccountNumber}</small>
  //             )}
  //           </div>
  //         </div>
  //         <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
  //           <div style={{ display: 'grid' }} className="col-5">
  //             <label className='form-label' style={{ fontWeight: '700' }}>IFSC Code</label>
  //             <input
  //               type="text"
  //               className="form-control"
  //               name="IFSCCode"
  //               value={formData.IFSCCode}
  //               onChange={handleInputChange}
  //             />
  //             {ifscMessage && (
  //               <small style={{ fontWeight: '800', color: isIfscValid ? "green" : "red" }}>
  //                 {ifscMessage}
  //               </small>
  //             )}
  //           </div>

  //           <div style={{ display: 'grid' }} className="col-5">
  //             <label className='form-label' style={{ fontWeight: '700' }}>Branch Name</label>
  //             <input
  //               type="text"
  //               className="form-control"
  //               name="Branch"
  //               value={formData.Branch}
  //               onChange={handleInputChange}
  //             />{formErrors.Branch && (
  //               <small style={{ color: "red", fontWeight: "bold" }}>{formErrors.Branch}</small>
  //             )}
  //           </div>

  //         </div>
  //         <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
  //           <div style={{ display: 'grid' }} className="col-5">
  //             <label className='form-label' style={{ fontWeight: '700' }}>Account Holder Name</label>
  //             <input
  //               type="text"
  //               className="form-control"
  //               name="AccountHodlerName"
  //               value={formData.AccountHodlerName}
  //               onChange={handleInputChange}
  //             />{formErrors.AccountHodlerName && (
  //               <small style={{ color: "red", fontWeight: "bold" }}>{formErrors.AccountHodlerName}</small>
  //             )}
  //           </div>

  //           <div style={{ display: 'grid' }} className="col-5">
  //             <label className='form-label' style={{ fontWeight: '700' }}>Deduction Type</label>
  //             <select
  //               className="form-select"
  //               name="DeductionID"
  //               value={formData.DeductionID}
  //               onChange={(e) => { handleInputChange(e); changeOptions(e, e.target.value) }}
  //             >
  //               <option value="" disabled>Select</option>
  //               {
  //                 fetchBanksDetails &&
  //                 fetchBanksDetails.map((val, index) => {
  //                   return (
  //                     <option key={index} value={val.DeductionID}>{val.Deduction_Name}</option>
  //                   )
  //                 })
  //               }
  //             </select>
  //           </div>
  //         </div>

  //         <div style={{ display: 'flex', paddingLeft: '4rem', gap: '10px' }}>
  //           <button type="submit" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: '#502eff', border: 'none', fontSize: '17px', gap: '4px' }}>{editId ? (<img src='' style={{ width: "1.2rem", paddingBottom: "3px" }} />) : (<img src={submit} alt="Submit" style={{ width: "1.2rem", paddingBottom: "3px" }} />)}{editId ? "Update" : "Submit"} </button>
  //           <button onClick={resetData} type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: 'red', border: 'none', fontSize: '17px', gap: '4px' }}><img src={Cancel32} style={{ width: '1.2rem', }} /> Cancel</button>
  //         </div>
  //       </div>
  //     </Form>

  //     {
  //       tableData &&
  //       <div style={{ display: 'grid', justifyContent: 'center', padding: "20px 0px 0px 0px", }}>
  //         <h4 style={{ padding: '10px', fontWeight: '700' }}>Add Tax List</h4>
  //         <div
  //           style={{
  //             display: 'flex',
  //             justifyContent: 'center',
  //             width: '75vw',
  //           }}
  //         >
  //           <table
  //             style={{
  //               backgroundColor: '#e8f7f3',
  //               width: '100%',
  //               borderRadius: '20px,20px 0px 0px',
  //               overflow: 'hidden',
  //             }}
  //           >
  //             <thead style={{ borderTop: 'none' }}>
  //               <tr
  //                 style={{
  //                   backgroundColor: '#ece9fe',
  //                   color: 'black',
  //                   border: 'none',
  //                   borderRadius: '10px',
  //                   overflow: 'hidden',
  //                   height: '2.5rem',
  //                 }}
  //               >
  //                 <th>Sr.No</th>
  //                 <th>Bank Name</th>
  //                 <th>Account Number</th>
  //                 <th>IFSC CODE</th>
  //                 <th>Branch Name</th>
  //                 <th>Account Holder Name</th>
  //                 <th>Use For</th>
  //                 <th>Actions</th>
  //               </tr>
  //             </thead>
  //             <tbody>
  //               {tableData.map((item, index) => (
  //                 <tr key={item.id} style={{
  //                   borderBottom: '2px dotted #ccc',
  //                   backgroundColor: 'white'
  //                 }}>
  //                   <td>{index + 1}</td>
  //                   <td>{item.Bank_Name}</td>
  //                   <td>{item.Account_Number}</td>
  //                   <td>{item.IFSC_CODE}</td>
  //                   <td>{item.Branch_Name}</td>
  //                   <td>{item.AccountHodlerName}</td>
  //                   <td>{item.UseFor}</td>
  //                   <td style={{ padding: '5px' }}>
  //                     <button onClick={() => handleEdit(item)} className="btn btn-custom-edit"
  //                       style={{
  //                         width: '5rem',
  //                         border: '1px solid #502eff',
  //                         backgroundColor: 'white',
  //                         borderRadius: '5px',
  //                         padding: '5px',
  //                         fontSize: '14px',
  //                         color: '#502eff',
  //                         fontWeight: '700'
  //                       }}
  //                     >
  //                       <img className="icon-edit" src={EditBlueBlue32} style={{ width: '1.3rem' }} /> Edit
  //                     </button>
  //                     <button onClick={(e) => handleDelete(e, item.DeductionID)} className="btn btn-custom-delete"
  //                       style={{
  //                         width: '6rem',
  //                         border: '1px solid #ee5d50',
  //                         backgroundColor: 'white',
  //                         borderRadius: '5px',
  //                         padding: '5px',
  //                         marginLeft: '10px',
  //                         color: '#ee5d50',
  //                         fontSize: '14px',
  //                         fontWeight: '700'
  //                       }}
  //                     >
  //                       <img className="icon-delete"
  //                         src={DeleteRed32}
  //                         style={{ width: '1.3rem', paddingBottom: '0.2rem' }}
  //                       />{' '}
  //                       Delete
  //                     </button>
  //                   </td>
  //                 </tr>
  //               ))}
  //             </tbody>
  //           </table>
  //         </div>
  //       </div>
  //     }

  //   </div>
  // )
  return (
    <div
      style={{
        paddingTop: "20px",
        backgroundColor: "rgb(246, 248, 252)",
        maxHeight: "91vh",
        overflowY: "auto",
      }}
    >
      <h4 style={{ margin: "10px" }}>{t("Bank Master")}</h4>
      <Form
        onSubmit={handleSubmit}
        ref={formdataref}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            marginBottom: 30,
            marginTop: 20,
            display: "grid",
            gap: "2rem",
            width: "70vw",
            border: "none",
            boxShadow: "0px 0px 10px",
            padding: "30px",
            backgroundColor: "white",
            borderRadius: "10px",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "20px",
              justifyContent: "space-evenly",
            }}
          >
            <div style={{ display: "grid" }} className="col-5">
              <label className="form-label" style={{ fontWeight: "700" }}>
                {t("Bank Name")}
              </label>
              <input
                type="text"
                className="form-control"
                name="BankName"
                value={formData.BankName}
                onChange={(e) => {
                  let value = e.target.value
                    .replace(/[^a-zA-Z0-9\s]/g, "")
                    .replace(/^\s+/, "");
                  handleInputChange({ target: { name: e.target.name, value } });
                }}
              />{" "}
              {formErrors.BankName && (
                <small style={{ color: "red", fontWeight: "bold" }}>
                  {formErrors.BankName}
                </small>
              )}
            </div>

            <div style={{ display: "grid" }} className="col-5">
              <label className="form-label" style={{ fontWeight: "700" }}>
                {t("Account Number")}
              </label>
              <input
                type="text"
                className="form-control"
                name="AccountNumber"
                value={formData.AccountNumber}
                onChange={(e) => {
                  let value = e.target.value
                    .replace(/[^0-9\s]/g, "")
                    .replace(/^\s+/, "");
                  handleInputChange({ target: { name: e.target.name, value } });
                }}
                minLength={9}
                maxLength={18}
              />
              {formErrors.AccountNumber && (
                <small style={{ color: "red", fontWeight: "bold" }}>
                  {formErrors.AccountNumber}
                </small>
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "20px",
              justifyContent: "space-evenly",
            }}
          >
            <div style={{ display: "grid" }} className="col-5">
              <label className="form-label" style={{ fontWeight: "700" }}>
                {t("IFSC Code")}
              </label>
              <input
                type="text"
                className="form-control"
                name="IFSCCode"
                value={formData.IFSCCode}
                onChange={(e) => {
                  let value = e.target.value
                    .replace(/[^a-zA-Z0-9\s]/g, "")
                    .replace(/^\s+/, "")
                    .toUpperCase();
                  handleInputChange({ target: { name: e.target.name, value } });
                }}
                minLength={11}
                maxLength={11}
              />
              {ifscMessage && (
                <small
                  style={{
                    fontWeight: "800",
                    color: isIfscValid ? "green" : "red",
                  }}
                >
                  {ifscMessage}
                </small>
              )}
            </div>

            <div style={{ display: "grid" }} className="col-5">
              <label className="form-label" style={{ fontWeight: "700" }}>
                {t("Branch Name")}
              </label>
              <input
                type="text"
                className="form-control"
                name="Branch"
                value={formData.Branch}
                onChange={(e) => {
                  let value = e.target.value
                    .replace(/[^a-zA-Z0-9\s]/g, "")
                    .replace(/^\s+/, "");
                  handleInputChange({ target: { name: e.target.name, value } });
                }}
              />
              {formErrors.Branch && (
                <small style={{ color: "red", fontWeight: "bold" }}>
                  {formErrors.Branch}
                </small>
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "20px",
              justifyContent: "space-evenly",
            }}
          >
            <div style={{ display: "grid" }} className="col-5">
              <label className="form-label" style={{ fontWeight: "700" }}>
                {t("Account Holder Name")}
              </label>
              <input
                type="text"
                className="form-control"
                name="AccountHodlerName"
                value={formData.AccountHodlerName}
                onChange={(e) => {
                  let value = e.target.value
                    .replace(/[^a-zA-Z0-9\s]/g, "")
                    .replace(/^\s+/, "");
                  handleInputChange({ target: { name: e.target.name, value } });
                }}
              />
              {formErrors.AccountHodlerName && (
                <small style={{ color: "red", fontWeight: "bold" }}>
                  {formErrors.AccountHodlerName}
                </small>
              )}
            </div>

            <div style={{ display: "grid" }} className="col-5">
              <label className="form-label" style={{ fontWeight: "700" }}>
                {t("Deduction Type")}
              </label>
              <select
                className="form-select"
                name="DeductionID"
                value={formData.DeductionID}
                onChange={(e) => {
                  handleInputChange(e);
                  changeOptions(e, e.target.value);
                }}
              >
                <option value="" disabled>
                  {t("Select")}
                </option>
                {fetchBanksDetails &&
                  fetchBanksDetails.map((val, index) => {
                    return (
                      <option key={index} value={val.DeductionID}>
                        {val.Deduction_Name}
                      </option>
                    );
                  })}
              </select>
            </div>
          </div>

          <div style={{ display: "flex", paddingLeft: "4rem", gap: "10px" }}>
            <button
              type="submit"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "20px",
                width: "8rem",
                height: "2.5rem",
                background:
                  "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                border: "none",
                fontSize: "16px",
                gap: "4px",
              }}
            >
              {editId ? (
                <img src="" style={{ width: "1.2rem", paddingBottom: "3px" }} />
              ) : (
                <img
                  src={submit}
                  alt="Submit"
                  style={{ width: "1.2rem", paddingBottom: "3px" }}
                />
              )}
              {editId ? t("Update") : t("Submit")}{" "}
            </button>
            <button
              onClick={resetData}
              type="button"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "20px",
                width: "7rem",
                height: "2.5rem",
                backgroundColor: "red",
                border: "none",
                fontSize: "17px",
                gap: "4px",
              }}
            >
              <img src={Cancel32} style={{ width: "1.2rem" }} /> {t("Cancel")}
            </button>
          </div>
        </div>
      </Form>

      {tableData && (
        <div
          className="m-auto mb-3"
          style={{
            backgroundColor: "white",
            padding: "40px 40px",
            boxShadow: "0px 0px 5px 1px #E4E8EC",
            borderRadius: "20px",
            width: "100%",
            maxWidth: "100%",
            overflowX: "hidden",
          }}
        >
          <h4 className="text-center fw-bold">{t("Bank List")}</h4>
          <div
            className="m-auto tableDesign"
            style={{ background: "#2C78DB", overflowX: "hidden" }}
          >
            <table
              className="m-0 p-0"
              style={{ width: "100%", borderCollapse: "collapse" }}
            >
              <thead>
                <tr
                  style={{
                    color: "white",
                    border: "none",
                    height: "3rem",
                    fontSize: "12px",
                  }}
                >
                  <th>{t("Sr.No")}</th>
                  <th>{t("Bank Name")}</th>
                  <th>{t("Account Number")}</th>
                  <th>{t("IFSC CODE")}</th>
                  <th>{t("Branch Name")}</th>
                  <th>{t("Account Holder Name")}</th>
                  <th>{t("Use For")}</th>
                  <th>{t("Actions")}</th>
                </tr>
              </thead>
              <tbody>
                {currentItems && currentItems.length > 0 ? (
                  currentItems.map((item, index) => {
                    const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";

                    return (
                      <tr
                        key={index}
                        style={{
                          backgroundColor: bgColor,
                          fontSize: "12px",
                          fontWeight: "500",
                        }}
                      >
                        <td style={{ width: "5%" }}>
                          {indexOfFirstBill + index + 1}
                        </td>
                        <td>{item.Bank_Name}</td>
                        <td>{item.Account_Number}</td>
                        <td>{item.IFSC_CODE}</td>
                        <td style={{ width: "28%" }}>{item.Branch_Name}</td>
                        <td style={{ width: "10%" }}>
                          {item.AccountHodlerName}
                        </td>
                        <td>{item.UseFor}</td>

                        <td style={{ padding: "5px" }}>
                          <button
                            onClick={() => handleEdit(item)}
                            className="btn btn-sm btn-primary"
                            style={{ marginRight: "10px" }}
                          >
                            {t("Edit")}
                          </button>

                          <button
                            className="btn btn-sm btn-danger"
                            onClick={(e) => handleDelete(e, item.DeductionID)}
                          >
                            {t("Delete")}
                          </button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan="8"
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "black",
                        background: "#CFE4F1",
                      }}
                    >
                      No Data Available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="col-12 mt-4 mb-2">
            <div className="row">
              <div className="col-6">
                <p className="text-gray-600" style={{ fontSize: "14px" }}>
                  {t("Showing")} {indexOfFirstBill + 1} {t("to")}{" "}
                  {Math.min(indexOfLastBill, tableData.length)} {t("of")}{" "}
                  {tableData.length} {t("entries")}
                </p>
              </div>
              <div
                className="col-6"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <button
                  onClick={() => setCurrentPage(1)}
                  disabled={currentPage === 1}
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    border: "1px solid lightgrey",
                    cursor: "pointer",
                    fontSize: "20px",
                    width: "2rem",
                  }}
                >
                  &laquo;
                </button>
                <button
                  onClick={() => setCurrentPage(currentPage - 1)}
                  disabled={currentPage === 1}
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    border: "1px solid lightgrey",
                    cursor: "pointer",
                    fontSize: "20px",
                    borderLeft: "none",
                    width: "2rem",
                  }}
                >
                  &lt;
                </button>
                <button
                  style={{
                    background:
                      "linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )",
                    color: "white",
                    cursor: "pointer",
                    fontSize: "20px",
                    width: "2.4rem",
                    border: "1px solid lightgrey",
                    borderLeft: "none",
                  }}
                >
                  {currentPage}
                </button>
                <button
                  onClick={() => setCurrentPage(currentPage + 1)}
                  disabled={currentPage === totalPages || totalPages === 0}
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    border: "1px solid lightgrey",
                    cursor: "pointer",
                    fontSize: "20px",
                    borderLeft: "none",
                    width: "2rem",
                  }}
                >
                  &gt;
                </button>
                <button
                  onClick={() => setCurrentPage(totalPages)}
                  disabled={currentPage === totalPages || totalPages === 0}
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    border: "1px solid lightgrey",
                    cursor: "pointer",
                    fontSize: "20px",
                    borderLeft: "none",
                    width: "2rem",
                  }}
                >
                  &raquo;
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Banks;
